import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Leaf, CheckCircle2, ArrowRight } from "lucide-react";

const CoachApplicationSuccessPage = () => {
  return (
    <div className="min-h-screen bg-[#FAFAF9] flex flex-col">
      {/* Header */}
      <header className="glass-header">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <Leaf className="w-8 h-8 text-[#7C9A92]" />
            <span className="font-serif text-2xl font-medium text-[#2C332B]">CoachBridge</span>
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center px-6 py-12">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          className="max-w-lg w-full text-center"
        >
          <div className="bg-white rounded-3xl p-12 border border-stone-100 shadow-lg">
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
              className="w-20 h-20 rounded-full bg-[#7C9A92]/10 flex items-center justify-center mx-auto mb-6"
            >
              <CheckCircle2 className="w-10 h-10 text-[#7C9A92]" />
            </motion.div>

            <h1 className="font-serif text-3xl md:text-4xl font-light text-[#2C332B] mb-4">
              Application Submitted!
            </h1>
            
            <p className="text-lg text-[#78716C] mb-8 leading-relaxed">
              Thank you for applying to become a CoachBridge coach. Our team will review your application and get back to you within 3-5 business days.
            </p>

            <div className="bg-[#F5F1E8] rounded-2xl p-6 mb-8">
              <h3 className="font-medium text-[#2C332B] mb-2">What happens next?</h3>
              <ul className="text-left text-[#78716C] space-y-2 text-sm">
                <li className="flex items-start gap-2">
                  <span className="text-[#7C9A92] font-bold">1.</span>
                  Our team reviews your application
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[#7C9A92] font-bold">2.</span>
                  We may reach out for a brief interview
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[#7C9A92] font-bold">3.</span>
                  Once approved, you'll receive onboarding materials
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[#7C9A92] font-bold">4.</span>
                  Your profile goes live and you start connecting with clients!
                </li>
              </ul>
            </div>

            <Link to="/">
              <Button
                className="rounded-full bg-[#7C9A92] hover:bg-[#6B8A82] text-white px-8 py-6 text-lg"
                data-testid="back-to-home-btn"
              >
                Back to Home
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
            </Link>
          </div>
        </motion.div>
      </main>
    </div>
  );
};

export default CoachApplicationSuccessPage;
